const React = require('react');

const Kit = require('./Kit.jsx');
const Name = require('./Name.jsx');
const Token = require('./Token.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('./Utilities.jsx');

const ArtistTypes = require('../artist/Types.jsx');
const CertificateTypes = require('../certificate/Types.jsx');
const CommonTypes = require('../common/Types.jsx');
const ConsignmentTypes = require('../consignment/Types.jsx');
const InvoiceTypes = require('../invoice/Types.jsx');
const LayoutTypes = require('../layout/Types.jsx');
const MosaicTypes = require('../mosaic/Types.jsx');
const OfferTypes = require('../offer/Types.jsx');
const PricelistTypes = require('../pricelist/Types.jsx');
const PurchaseOrderTypes = require('../purchaseOrder/Types.jsx');
const TearsheetTypes = require('../tearsheet/Types.jsx');

const Types = {
    CollateralBlocks: {},

    defaultConfig: (type) => {
        const documentConfig = {
            blocks: [],
            document: {
                config: {},
                id: Utilities.Config.Id.DocumentSettings
            }
        };
        const config = Types.Document.settings(type).config;
        for (let id in config) {
            documentConfig.document.config[id] = Utilities.Config.getMap(config[id], 'options');
        }
        return documentConfig;
    },
    getBlock: (id, type, data, legacy) => {
        let contentBlocks = Types.CollateralBlocks[type];
        switch (type) {
            case Name.Config.ArtistBio:
            case Name.Config.CertificateOfAuthenticity:
            case Name.Config.Consignment:
            case Name.Config.Invoice:
            case Name.Config.Mosaic:
            case Name.Config.Offer:
            case Name.Config.Pricelist:
            case Name.Config.Tearsheet:
                if (legacy == true) {
                    contentBlocks = Types.LegacyBlocks[type];
                    break;
                }
            // Intentional fallthrough
            case Name.Config.PurchaseOrder:
            case Name.Content.ArtistBioItem:
            case Name.Content.ArtistInventoryItem:
            case Name.Content.CertificateItem:
            case Name.Content.ConsignmentLineItem:
            case Name.Content.CreditLineItem:
            case Name.Content.InvoiceLineItem:
            case Name.Content.MosaicItem:
            case Name.Content.PageHeader:
            case Name.Content.PaymentLineItem:
            case Name.Content.PricelistInventoryItem:
            case Name.Content.PurchaseOrderLineItem:
            case Name.Content.TearsheetItem:
                contentBlocks = contentBlocks(data);
                break;
        }
        if (!contentBlocks) {
            return null;
        }
        let temp;
        for (let i = 0; i < contentBlocks.length; i++) {
            temp = contentBlocks[i];
            if (temp.id != id) {
                continue;
            }
            return temp;
        }
        for (let i = 0; i < Types.LayoutBlocks.length; i++) {
            temp = Types.LayoutBlocks[i];
            if (temp.id != id) {
                continue;
            }
            return temp;
        }
        return null;
    },
    getBlockTokens: (block, type, data) => {
        if (!block) {
            return null;
        }
        switch (block.id) {
            case Name.Block.Company.ContactMeta:
                return CommonTypes.BlocksV2.tokens(block.id);
        }
        switch (type) {
            case Name.Config.ArtistBio:
                return ArtistTypes.Blocks.tokens(block.id, data);
            case Name.Config.CertificateOfAuthenticity:
                return CertificateTypes.Blocks.tokens(block.id, data);
            case Name.Config.Consignment:
                return ConsignmentTypes.Blocks.tokens(block.id, data);
            case Name.Config.Invoice:
                return InvoiceTypes.Blocks.tokens(block.id, data);
            case Name.Config.Mosaic:
                return MosaicTypes.Blocks.tokens(block.id, data);
            case Name.Config.Offer:
                return OfferTypes.Blocks.tokens(block.id, data);
            case Name.Config.Pricelist:
                return PricelistTypes.Blocks.tokens(block.id, data);
            case Name.Config.PurchaseOrder:
                return PurchaseOrderTypes.Blocks.tokens(block.id, data);
            case Name.Config.Tearsheet:
                return TearsheetTypes.Blocks.tokens(block.id, data);
        }
    },
    getDisplay: function (block, type) {
        if (!block || !block.Id) {
            return undefined;
        }
        const index = block.Id.indexOf('-');
        if (index < 0) {
            return undefined;
        }
        const id = block.Id.substring(0, index);
        const _block = Types.getBlock(id, type, undefined, true);
        return _block ? _block.display : undefined;
    },
    getDisplayV2: (blockType, configType) => {
        if (!blockType) {
            return 'Unknown Block';
        }
        switch (blockType.value) {
            case Name.Block.Artist.Container:
                return 'Artist Container';
            case Name.Block.Artist.Image:
                return 'Artist Image';
            case Name.Block.Artist.Meta:
                return 'Artist Meta';
            case Name.Block.AuthenticityStatement:
                return 'Authenticity Statement'
            case Name.Block.Client.ContactMeta:
                return 'Customer Contact Info';
            case Name.Block.Columns:
                return 'Columns';
            case Name.Block.Company.ContactMeta:
                return 'Company Contact Info';
            case Name.Block.Company.Logo:
                return 'Logo';
            case Name.Block.Company.StaffName:
                return 'Staff Name';
            case Name.Block.Consignment.Meta:
                return 'Consignment Meta';
            case Name.Block.Consignment.Terms:
                return 'Consignment Terms';
            case Name.Block.Consignment.Totals:
                return 'Totals';
            case Name.Block.Date:
                switch (configType) {
                    case Name.Config.Consignment:
                        return 'Term Date';
                    case Name.Config.Invoice:
                        return 'Invoice Date';
                    case Name.Config.Offer:
                        return 'Offer Date';
                    case Name.Config.PurchaseOrder:
                        return 'Purchase Order Date';
                }
                return 'Date';
            case Name.Block.Inventory.Container:
                return 'Item Container';
            case Name.Block.Inventory.Image:
                return 'Item Image';
            case Name.Block.Inventory.List:
                switch (configType) {
                    case Name.Config.PurchaseOrder:
                        return 'Line Items';
                }
                return 'Items List';
            case Name.Block.Inventory.Meta:
            case Name.Block.ListOrderNumber:
                return 'Item Meta';
            case Name.Block.ListTitle:
                return 'List Title';
            case Name.Block.Name:
                switch (configType) {
                    case Name.Config.PurchaseOrder:
                        return 'Purchase Order Name';
                }
                return 'Name';
            case Name.Block.NonBreakingContainer:
                return 'Non-Breaking Container';
            case Name.Block.Notes:
                return 'Notes';
            case Name.Block.Number:
                switch (configType) {
                    case Name.Config.Invoice:
                        return 'Invoice Number';
                    case Name.Config.PurchaseOrder:
                        return 'Purchase Order Number';
                }
                return 'Number';
            case Name.Block.PaymentCredit.Amount:
            case Name.Block.PaymentCredit.Date:
            case Name.Block.PaymentCredit.Method:
                return 'Payment Meta';
            case Name.Block.PaymentCredit.CreditsContainer:
                return 'Credits Table';
            case Name.Block.PaymentCredit.PaymentsContainer:
                return 'Payments Table';
            case Name.Block.Separator:
                return 'Divider';
            case Name.Block.Signature:
                return 'Signature Line';
            case Name.Block.Stage:
                return 'Stage';
            case Name.Block.TaxLine:
                return 'GST Tax Line';
            case Name.Block.Text:
                return 'Text';
            case Name.Block.Total.Balance:
                return 'Balance';
            case Name.Block.Total.Discount:
                return 'Discount';
            case Name.Block.Total.GrandTotal:
                return 'Grand Total';
            case Name.Block.Total.Paid:
                return 'Total Paid';
            case Name.Block.Total.PromoCodes:
                return 'Promo Codes';
            case Name.Block.Total.Refunded:
                return 'Total Refunded';
            case Name.Block.Total.Shipping:
                return 'Shipping';
            case Name.Block.Total.Subtotal:
                return 'Subtotal';
            case Name.Block.Total.Taxes:
                return 'Taxes';
            case Name.Block.TrackingNumber:
                return 'Tracking Number';
            case Name.Block.ValidThrough:
                return 'Valid Through';
            default:
                return `Unknown block type value: ${blockType.value}`;
        }
    },
    getTitle: function (type) {
        switch (type) {
            case Name.Config.ArtistBio:
                return 'Artist Bio';
            case Name.Config.CertificateOfAuthenticity:
                return 'Certificate of Authenticity';
            case Name.Config.Consignment:
                return 'Consignment';
            case Name.Config.Invoice:
                return 'Invoice';
            case Name.Config.Mosaic:
                return 'Mosaic';
            case Name.Config.Offer:
                return 'Offer';
            case Name.Config.Pricelist:
                return 'Pricelist';
            case Name.Config.PurchaseOrder:
                return 'Purchase Order';
            case Name.Config.Tearsheet:
                return 'Tearsheet';
            default:
                return '';
        }
    },
    hasPageHeader: function (type) {
        switch (type) {
            case Name.Config.ArtistBio:
            case Name.Config.CertificateOfAuthenticity:
            case Name.Config.Mosaic:
            case Name.Config.Tearsheet:
                return true;
            default:
                return false;
        }
    },
    isBlockAllowedInsideLayout: (blockType, parentLayoutType) => {
        switch (parentLayoutType) {
            case Name.Block.Columns:
                switch (blockType) {
                    case Name.Block.Columns:
                    case Name.Block.Inventory.List:
                    case Name.Block.NonBreakingContainer:
                        return false;
                }
                break;
            case Name.Block.NonBreakingContainer:
                switch (blockType) {
                    case Name.Block.NonBreakingContainer:
                        return false;
                }
        }
        return true;
    },

    visibility: {
        hasFooter: (config) => config.PDF && config.PDF.footer
    }
};

// #region CONFIG TYPES

Types.CollateralBlocks[Name.Config.ArtistBio] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...ArtistTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.CertificateOfAuthenticity] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...CertificateTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.Consignment] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...ConsignmentTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.Invoice] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...InvoiceTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.Mosaic] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...MosaicTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.Offer] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...OfferTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.Pricelist] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...PricelistTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.PurchaseOrder] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...PurchaseOrderTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Config.Tearsheet] = (data) => [
    ...CommonTypes.BlocksV2.get(0),
    ...TearsheetTypes.Blocks.get(0, data),
    ...LayoutTypes.BlocksV2.get(1)
];

// #endregion CONFIG TYPES

// #region CONTENT TYPES

Types.CollateralBlocks[Name.Content.ArtistBioItem] = () => [
    ...ArtistTypes.Blocks.content[Name.Block.Artist.Container].get(0),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.ArtistBioItem)
];

Types.CollateralBlocks[Name.Content.ArtistInventoryItem] = () => [
    ...ArtistTypes.Blocks.content[Name.Block.Inventory.Container].get(0),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.ArtistInventoryItem)
];

Types.CollateralBlocks[Name.Content.CertificateItem] = (data) => [
    ...CertificateTypes.Blocks.content[Name.Block.Inventory.Container].get(0, data),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.CertificateItem)
];

Types.CollateralBlocks[Name.Content.ConsignmentLineItem] = (data) => [
    ...ConsignmentTypes.Blocks.content[Name.Block.Inventory.List].get(0, data),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.ConsignmentLineItem)
];

Types.CollateralBlocks[Name.Content.CreditLineItem] = (data) => [
    ...InvoiceTypes.Blocks.content[Name.Block.PaymentCredit.CreditsContainer].get(0, data),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.CreditLineItem)
];

Types.CollateralBlocks[Name.Content.InvoiceLineItem] = () => [
    ...InvoiceTypes.Blocks.content[Name.Block.Inventory.List].get(0),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.InvoiceLineItem)
];

Types.CollateralBlocks[Name.Content.MosaicItem] = (data) => [
    ...MosaicTypes.Blocks.content[Name.Block.Inventory.Container].get(0, data),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.MosaicItem)
];

Types.CollateralBlocks[Name.Content.PageHeader] = () => [
    ...CommonTypes.BlocksV2.get(0),
    ...LayoutTypes.BlocksV2.get(1)
];

Types.CollateralBlocks[Name.Content.PaymentLineItem] = (data) => [
    ...InvoiceTypes.Blocks.content[Name.Block.PaymentCredit.PaymentsContainer].get(0, data),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.PaymentLineItem)
];

Types.CollateralBlocks[Name.Content.PricelistInventoryItem] = () => [
    ...PricelistTypes.Blocks.content[Name.Block.Inventory.List].get(0),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.PricelistInventoryItem)
];

Types.CollateralBlocks[Name.Content.PurchaseOrderLineItem] = () => [
    ...PurchaseOrderTypes.Blocks.content[Name.Block.Inventory.List].get(0),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.PurchaseOrderLineItem)
];

Types.CollateralBlocks[Name.Content.TearsheetItem] = (data) => [
    ...TearsheetTypes.Blocks.content[Name.Block.Inventory.Container].get(0, data),
    ...LayoutTypes.BlocksV2.get(1, Name.Content.TearsheetItem)
];

// #endregion CONTENT TYPES

Types.Document = {
    settingsLegacy: {
        id: Utilities.Config.Id.DocumentSettings,
        config: {
            Style: {
                label: 'Document Layout',
                options: [
                    {
                        display: 'Margin Top',
                        name: 'paddingTop',
                        type: 'text',
                        value: '20px'
                    },
                    {
                        display: 'Margin Bottom',
                        name: 'paddingBottom',
                        type: 'text',
                        value: '40px'
                    },
                    {
                        display: 'Margin Left',
                        name: 'paddingLeft',
                        type: 'text',
                        value: '40px'
                    },
                    {
                        display: 'Margin Right',
                        name: 'paddingRight',
                        type: 'text',
                        value: '40px'
                    }
                ]
            },
            PDF: {
                expanded: false,
                helpText: () => <span>Values are in millimeters (do not include units) and apply to each page<br />NOTE: Builder/preview will not reflect these changes - only PDF exports</span>,
                label: 'PDF Page Layout',
                options: [
                    {
                        display: 'Page Margin Top',
                        name: 'pageMarginTop',
                        type: 'text',
                        value: '10'
                    },
                    {
                        display: 'Page Margin Bottom',
                        name: 'pageMarginBottom',
                        type: 'text',
                        value: '10'
                    },
                    {
                        display: 'Page Margin Left',
                        name: 'pageMarginLeft',
                        type: 'text',
                        value: '10'
                    },
                    {
                        display: 'Page Margin Right',
                        name: 'pageMarginRight',
                        type: 'text',
                        value: '10'
                    },
                    { display: 'Footer Properties', id: 'footerProps', type: 'header' },
                    {
                        display: 'Include Footer',
                        fullWidth: true,
                        name: 'footer',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        display: 'Text Override',
                        fullWidth: true,
                        helpText: () => <span>Leave blank to use auto-generated address footer</span>,
                        name: 'textFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Text Color',
                        name: 'colorFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Text Size',
                        name: 'fontSizeFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Font Weight',
                        name: 'fontWeightFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Font Style',
                        name: 'fontStyleFooter',
                        options: [
                            { display: 'Normal', value: 'normal' },
                            { display: 'Italic', value: 'italic' }
                        ],
                        type: 'dropdown',
                        value: 'normal',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Padding Top',
                        name: 'paddingTopFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Padding Bottom',
                        name: 'paddingBottomFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Padding Left',
                        name: 'paddingLeftFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    },
                    {
                        display: 'Padding Right',
                        name: 'paddingRightFooter',
                        type: 'text',
                        visible: function (config) {
                            return config.PDF && config.PDF.footer;
                        }
                    }
                ]
            }
        }
    },
    settings: (type) => {
        const config = {
            id: Utilities.Config.Id.DocumentSettings,
            config: {
                Style: {
                    group: 'Style',
                    label: 'Document Layout',
                    options: [
                        {
                            disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                            display: 'Padding',
                            group: 'Style',
                            name: 'paddingMargin',
                            options: TypeConfig.dropdown.measurement(),
                            type: 'paddingMargin',
                            value: {
                                paddingBottom: { unit: 'px', value: '40' },
                                paddingLeft: { unit: 'px', value: '40' },
                                paddingRight: { unit: 'px', value: '40' },
                                paddingTop: { unit: 'px', value: '40' }
                            }
                        },
                    ]
                },
                PDF: {
                    expanded: false,
                    group: 'PDF',
                    // helpText: () => <span>Values are in millimeters (do not include units) and apply to each page<br />NOTE: Builder/preview will not reflect these changes - only PDF exports</span>,
                    label: 'PDF Page Layout',
                    options: [
                        {
                            fullWidth: true,
                            group: 'PDF',
                            type: 'info',
                            value: () => `<span>Values are in millimeters and apply to each page<br />NOTE: Builder/preview will not reflect these changes</span>`
                        },
                        {
                            display: 'Page Margin Top',
                            group: 'PDF',
                            name: 'pageMarginTop',
                            type: 'numeric-positive',
                            value: '10'
                        },
                        {
                            display: 'Page Margin Bottom',
                            group: 'PDF',
                            name: 'pageMarginBottom',
                            type: 'numeric-positive',
                            value: '10'
                        },
                        {
                            display: 'Page Margin Left',
                            group: 'PDF',
                            name: 'pageMarginLeft',
                            type: 'numeric-positive',
                            value: '10'
                        },
                        {
                            display: 'Page Margin Right',
                            group: 'PDF',
                            name: 'pageMarginRight',
                            type: 'numeric-positive',
                            value: '10'
                        },
                        {
                            display: 'Footer Properties',
                            group: 'PDF',
                            id: 'footerProps',
                            type: 'header'
                        },
                        {
                            display: 'Include Footer',
                            fullWidth: true,
                            group: 'PDF',
                            name: 'footer',
                            type: 'checkbox',
                            value: true
                        },
                        {
                            display: 'Text Override',
                            fullWidth: true,
                            group: 'PDF',
                            helpText: () => <span>Leave blank to use auto-generated address footer</span>,
                            name: 'textFooter',
                            type: 'text',
                            visible: Types.visibility.hasFooter
                        },
                        {
                            display: 'Text Color',
                            group: 'PDF',
                            name: 'colorFooter',
                            type: 'color-left',
                            visible: Types.visibility.hasFooter
                        },
                        {
                            display: 'Text Size',
                            group: 'PDF',
                            name: 'fontSizeFooter',
                            options: TypeConfig.dropdown.measurement(),
                            type: 'measurement',
                            visible: Types.visibility.hasFooter
                        },
                        {
                            display: 'Font Weight',
                            group: 'PDF',
                            name: 'fontWeightFooter',
                            options: [
                                { display: 'Normal', value: 'normal' },
                                { display: 'Bold', value: 'bold' }
                            ],
                            type: 'dropdown',
                            value: 'normal',
                            visible: Types.visibility.hasFooter
                        },
                        {
                            display: 'Font Style',
                            group: 'PDF',
                            name: 'fontStyleFooter',
                            options: [
                                { display: 'Normal', value: 'normal' },
                                { display: 'Italic', value: 'italic' }
                            ],
                            type: 'dropdown',
                            value: 'normal',
                            visible: Types.visibility.hasFooter
                        },
                        {
                            disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                            display: 'Padding',
                            group: 'PDF',
                            name: 'paddingMarginFooter',
                            nameSuffix: 'Footer',
                            options: TypeConfig.dropdown.measurement(),
                            type: 'paddingMargin',
                            visible: Types.visibility.hasFooter
                        }
                    ]
                }
            }
        }
        switch (type) {
            case Name.Config.ArtistBio:
            case Name.Config.CertificateOfAuthenticity:
            case Name.Config.Mosaic:
            case Name.Config.Tearsheet:
                config.config.Style.options.splice(0, 0, {
                    display: 'Edit Page Header',
                    fullWidth: true,
                    group: 'Style',
                    offsetTop: true,
                    type: 'edit-button',
                    value: {
                        keyPath: ['Style', 'pageHeader'],
                        name: Name.Content.PageHeader
                    }   
                });
                break;
        }
        return config;
    },
    defaultMap: function () {
        const document = {
            Config: {},
            Id: Utilities.Config.Id.DocumentSettings
        };
        const config = Types.Document.settingsLegacy.config;
        for (let id in config) {
            document.Config[id] = Utilities.Config.getMap(config[id], 'options');
        }
        return document;
    },
    getPDFParameters: function (config) {
        let configProps, params;
        if (config) {
            if (config.Document && config.Document.Config) {
                configProps = config.Document.Config.PDF;
            } else if (config.Config && config.Config.document && config.Config.document.config) {
                configProps = config.Config.document.config.PDF;
            }
        }
        if (configProps) {
            params = {};
            params.Margins = {
                Bottom: configProps.pageMarginBottom,
                Left: configProps.pageMarginLeft,
                Right: configProps.pageMarginRight,
                Top: configProps.pageMarginTop
            };
            let footer = true;
            if (configProps.footer != undefined) {
                footer = configProps.footer;
            }
            params.Includes = { Footer: footer };

            params.Footer = {
                Color: configProps.colorFooter,
                FontSize: configProps.fontSizeFooter,
                FontStyle: configProps.fontStyleFooter,
                FontWeight: configProps.fontWeightFooter,
                PaddingBottom: configProps.paddingBottomFooter,
                PaddingLeft: configProps.paddingLeftFooter,
                PaddingRight: configProps.paddingRightFooter,
                PaddingTop: configProps.paddingTopFooter,
                Text: configProps.textFooter
            }
            if (params.Footer.FontSize && params.Footer.FontSize.unit) {
                params.Footer.FontSize = `${params.Footer.FontSize.value}${params.Footer.FontSize.unit}`;
            }
            if (params.Footer.PaddingBottom && params.Footer.PaddingBottom.unit) {
                params.Footer.PaddingBottom = `${params.Footer.PaddingBottom.value}${params.Footer.PaddingBottom.unit}`;
            }
            if (params.Footer.PaddingLeft && params.Footer.PaddingLeft.unit) {
                params.Footer.PaddingLeft = `${params.Footer.PaddingLeft.value}${params.Footer.PaddingLeft.unit}`;
            }
            if (params.Footer.PaddingRight && params.Footer.PaddingRight.unit) {
                params.Footer.PaddingRight = `${params.Footer.PaddingRight.value}${params.Footer.PaddingRight.unit}`;
            }
            if (params.Footer.PaddingTop && params.Footer.PaddingTop.unit) {
                params.Footer.PaddingTop = `${params.Footer.PaddingTop.value}${params.Footer.PaddingTop.unit}`;
            }
        }
        return params;
    }
};

Types.LegacyBlocks = {
    [Name.Config.ArtistBio]: [
        ...CommonTypes.Blocks,
        ...ArtistTypes.Blocks.legacy
    ],
    [Name.Config.CertificateOfAuthenticity]: [
        ...CommonTypes.Blocks,
        ...CertificateTypes.Blocks.legacy
    ],
    [Name.Config.Consignment]: [
        ...CommonTypes.Blocks,
        ...ConsignmentTypes.Blocks.legacy
    ],
    [Name.Config.Invoice]: [
        ...CommonTypes.Blocks,
        ...InvoiceTypes.Blocks.legacy
    ],
    [Name.Config.Mosaic]: [
        ...CommonTypes.Blocks,
        ...MosaicTypes.Blocks.legacy
    ],
    [Name.Config.Offer]: [
        ...CommonTypes.Blocks,
        ...OfferTypes.Blocks.legacy
    ],
    [Name.Config.Pricelist]: [
        ...CommonTypes.Blocks,
        ...PricelistTypes.Blocks.legacy
    ],
    [Name.Config.Tearsheet]: [
        ...CommonTypes.Blocks,
        ...TearsheetTypes.Blocks.legacy
    ]
}

Types.Kit = Kit;
Types.LayoutBlocks = LayoutTypes.Blocks;
Types.Name = Name;
Types.Token = Token;

module.exports = Types;
